<cc-top-bar [title]="'SUBSCRIPTION_PAYMENT' | translate"></cc-top-bar>
<cc-payment-spinner *ngIf="spinner"></cc-payment-spinner>

<cc-payment-confirmer
  [activeCard]="activeCard"
  [paymentParams]="paymentStatusParams"
  [subscriptionParams]="subscriptionParams"
  [user]="user"
  (confirmed)="onConfirm($event)">
</cc-payment-confirmer>
